import { Box, Typography, useTheme } from '@mui/material';

interface ProgressCircleProps {
  progress: number;
  status: string;
  testName: string;
}

export function ProgressCircle({ progress, status, testName }: ProgressCircleProps) {
  const theme = useTheme();
  
  const radius = 80;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;
  
  // Use theme colors for the progress circle
  const bgStroke = theme.palette.divider || '#E0E0E0';
  const progressStroke = theme.palette.primary.main;

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 400,
    }}>
      {/* Circular Progress SVG */}
      <Box sx={{ position: 'relative', width: 200, height: 200 }}>
        <svg width="200" height="200" style={{ transform: 'rotate(-90deg)' }}>
          {/* Background circle */}
          <circle
            cx="100"
            cy="100"
            r={radius}
            stroke={bgStroke}
            strokeWidth="12"
            fill="none"
          />
          {/* Progress circle */}
          <circle
            cx="100"
            cy="100"
            r={radius}
            stroke={progressStroke}
            strokeWidth="12"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{ 
              transition: 'stroke-dashoffset 0.5s ease',
            }}
          />
        </svg>
        
        {/* Percentage text in center */}
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}>
          <Typography variant="h3" sx={{ fontWeight: 600, color: 'text.primary' }}>
            {Math.round(progress)}%
          </Typography>
        </Box>
      </Box>
      
      {/* Status text */}
      <Typography 
        variant="body1" 
        sx={{ mt: 3, fontWeight: 500, color: 'text.primary' }}
      >
        {status}
      </Typography>
      
      {/* Test name */}
      <Typography 
        variant="body2" 
        sx={{ mt: 1, color: 'text.secondary' }}
      >
        {testName}
      </Typography>
    </Box>
  );
}
